import {DeleteOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {FormListFieldData} from 'antd/es/form/FormList';
import React, {FC} from 'react';

import {EComparisonType} from 'components/form/hooks/use-form-watcher/use-form-watcher-constants';
import {CustomSelect} from 'components/form/inputs/custom-select';

import {numberLengthValidationRule, requiredInputRule} from '../../utils';

interface IMainInfoTerritoryItemProps {
    field: FormListFieldData;
    index: number;
    onRemove: (name: number) => void;
}

export const MainInfoTerritoryItem: FC<IMainInfoTerritoryItemProps> = ({
    field,
    index,
    onRemove,
}: IMainInfoTerritoryItemProps) => (
    <div className="project-item-block">
        {index !== 0 && (
            <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onRemove(field.name)}
                className="delete-button"
            />
        )}
        <div className="form-flex-row">
            <Form.Item
                name={[field.name, 'cadastralNumber']}
                label="Кадастровый номер земельного участка, на котором планируется реализация инвестиционного проекта"
                rules={index === 0 ? [requiredInputRule()] : []}
            >
                <Input placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={[field.name, 'propertyType']}
                label="Тип пользования собственностью"
                rules={index === 0 ? [requiredInputRule()] : []}
            >
                <CustomSelect
                    settings={{
                        placeholder: 'Выберите вариант ответа',
                        url: 'valueLists/FLEX_VALUE?sublistCode=property_type',
                        valuePath: 'lookupCode',
                        labelPath: 'description',
                    }}
                />
            </Form.Item>
            <Form.Item
                name={[field.name, 'regionCode']}
                label="Местонахождение: Код субъекта Российской Федерации"
                rules={
                    index === 0
                        ? [
                            requiredInputRule(),
                            numberLengthValidationRule({comparisonOperator: EComparisonType.GREATER, value: 8}),
                            numberLengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 11}),
                        ]
                        : [
                            numberLengthValidationRule({comparisonOperator: EComparisonType.GREATER, value: 8}),
                            numberLengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 11}),
                        ]
                }
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
        </div>
    </div>
);
